/**
 * cl-core/config — CL app_config 키 상수·파서 (지시서 §1-2 · §1-5). 순수 TS.
 *
 * app_config 는 (namespace, key) 2열 키다. CL 은 namespace 'cl' 을 쓴다.
 *  - cl/title_v2           = { detail, region, cafe } (불리언) — 기본 전부 off, 배포 후 post_deploy 로 켠다.
 *  - cl/owner_sales_sites  = site_id(uuid) 배열 — Node 직접 영업 현장. AI 상상도 대신 공식 이미지·카드만.
 * ⚠️ 여기서 DB 를 읽지 않는다. 읽기는 호출부(Next: lib/app-config getConfig('cl', …)).
 */

export const CL_CONFIG_NAMESPACE = 'cl';
export const CL_KEY_TITLE_V2 = 'title_v2';
export const CL_KEY_OWNER_SALES_SITES = 'owner_sales_sites';
/** cl/rank_lock = RankLockFile(레인 0 적재 — 순위 보유 T0 URL) · cl/detail_v2 = 상세 CL 템플릿 on/off(키 없으면 on). hc3 통합 HC-A-033. */
export const CL_KEY_RANK_LOCK = 'rank_lock';
/** naver-rank R1 — 자동 해제 목록({ urls, generated_at, rule }). DB 함수 cl_rank_lock_release_refresh 가 매일 쓴다. */
export const CL_KEY_RANK_LOCK_RELEASED = 'rank_lock_released';
export const CL_KEY_DETAIL_V2 = 'detail_v2';

/** 초기값: 엄궁역 트라비스 하늘채(apt_sites.id · 2026-10-15 실측). */
export const OWNER_SALES_SITES_DEFAULT: readonly string[] = ['1ce61b1a-9e47-491d-b9e6-590649dbec82'];

/** 값 파싱. 배열이 아니면 기본값. 문자열만 남긴다. */
export function parseOwnerSalesSites(value: unknown): string[] {
  if (!Array.isArray(value)) return [...OWNER_SALES_SITES_DEFAULT];
  return value.map((v) => String(v ?? '').trim()).filter(Boolean);
}

export function isOwnerSalesSite(siteId: string | null | undefined, list: readonly string[]): boolean {
  return !!siteId && list.indexOf(String(siteId)) >= 0;
}

/**
 * 이벤트 이미지 작업 등급 하한 — image_jobs.priority ≥ 이 값인 site_hero 는 «이벤트 작업»(예산 예약분으로 생성).
 * 단일 출처(hc3 H6): 생산자 content-v2/event-images.ts 와 소비자 imagegen/pure.ts(레인 b — 통합 단계에서 이 상수 import 로 교체)가 같은 값을 써야 한다.
 */
export const EVENT_JOB_PRIORITY_MIN = 500000;

/** 자체 이미지 저장소(Supabase Storage 커스텀 도메인) 호스트 — 단일 출처(hc3 H6 · blog/safe-image · blog/list-v3). */
export const STORED_IMAGE_HOST = 'kadeora.supabase.co';

/** 운영 Supabase 프로젝트 기본 호스트({ref}.supabase.co) — env(NEXT_PUBLIC_SUPABASE_URL)가 없을 때의 단일 대체값(HC 정리 2026-10-24). */
export const SUPABASE_PROJECT_HOST = 'tezftxakuwhsclarprlz.supabase.co';

/**
 * 외부 채널(카페·블로그·Deno 생성기)에 싣는 정식 출처 origin — env 와 무관하게 운영 도메인 고정(hc3 H5·H6 단일 출처).
 * Next 화면용 SITE_URL(lib/constants, env 우선)과 용도가 다르다: 밖으로 나간 링크는 미리보기 도메인이면 안 된다.
 */
export const CANONICAL_ORIGIN = 'https://kadeora.app';
